import { render, staticRenderFns } from "./game-card-mobile.vue?vue&type=template&id=3799f6d7&scoped=true"
import script from "./game-card-mobile.vue?vue&type=script&lang=js"
export * from "./game-card-mobile.vue?vue&type=script&lang=js"
import style0 from "./game-card-mobile.vue?vue&type=style&index=0&id=3799f6d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3799f6d7",
  null
  
)

export default component.exports